import { EOfficeType, Filters } from 'shared/types/filters';

export function includesWarehouseOfficeType(filters: Filters): boolean {
  return filters.officeType.includes(EOfficeType.Warehouse);
}
